class pswpElement {
  constructor() {
    (this.items = []),
      document
        .querySelectorAll("[data-product-media-photoswipe]")
        .forEach((e, t) => {
          this.items[t] = {
            src: e.dataset.src,
            w: parseInt(e.dataset.width, 10),
            h: parseInt(e.dataset.height, 10),
          };
        }),
      0 !== this.items.length && this.gallery();
  }
  gallery() {
    let e = document.querySelectorAll(".pswp")[0],
      t = (t) => {
        let a = parseInt(t, 10),
          s = new PhotoSwipe(e, PhotoSwipeUI_Default, this.items, {
            index: a,
            preload: [1, 3],
            closeOnScroll: !1,
            closeOnVerticalDrag: !1,
            shareEl: !1,
            history: !1,
          });
        s.init();
      };
    document
      .querySelectorAll("[data-product-media-photoswipe]")
      .forEach((e, t) => {
        this.items[t] = {
          src: e.dataset.src,
          w: parseInt(e.dataset.width, 10),
          h: parseInt(e.dataset.height, 10),
        };
      }),
      document
        .querySelectorAll("[data-product-media-photoswipe]")
        .forEach((e) =>
          e.addEventListener("click", (e) => {
            e.preventDefault();
            let a = e.currentTarget.dataset.index;
            t(a);
          })
        );
  }
}
new pswpElement();
